export abstract class AuthGuardedPage { 
    userSubject$;

    constructor(public commonService){
    }

    init(self, authDependantFx){
        this.commonService.getUserSubject().subscribe(resp => {
            if (resp && resp.login){
                authDependantFx(self, resp)          
            } 
        }); 
    };

    logout(self, logoutFx){
        this.commonService.getLogoutObservable().subscribe(t => {
            if(t) {
                logoutFx(self);
            }
        });
    }
}
